import { createFileRoute, notFound } from "@tanstack/react-router";
import { RunDetailPage } from "@/features/runs/RunDetailPage";
import { ApiError } from "@/lib/api/client";
import { runDetailQuery } from "@/lib/api/queries";

export const Route = createFileRoute("/w/$workspace/p/$project/runs/$runId")({
  loader: async ({ context, params }) => {
    try {
      return await context.queryClient.ensureQueryData(
        runDetailQuery(params.workspace, params.project, params.runId),
      );
    } catch (e) {
      if (e instanceof ApiError && e.status === 404) throw notFound();
      throw e;
    }
  },
  component: () => {
    const { workspace, project, runId } = Route.useParams();
    return <RunDetailPage workspace={workspace} project={project} runId={runId} />;
  },
});
